import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import Select from 'react-select'
import {RadioGroup, Radio} from 'react-radio-group'
import { Row, Col } from 'react-flexbox-grid'
import ReactTooltip from 'react-tooltip'
import {SlideDown} from 'react-slidedown'
import config from '../../config'
import format from '../../helpers/format'
import {
  LinkIcon,
} from '../../components'
import Styles from './IyvListFilters.css'


@CSSModules(Styles, {allowMultiple:true})
class IyvListGroupControl extends Component {
  static propTypes = {
    activeGrouping: PropTypes.string,
    changeActiveGrouping: PropTypes.func
  }
  //
  constructor(props) {
    super(props)
    const params = [['All funds','rank'],
                    ['By group','group'],
                    ['By category','peer']]
    const tooltipText = `
      Change the grouping used in the gender equality ranking. You can
      group funds in three ways. The letter grade is always based on
      the default setting, Groups.
      <ul style="padding-inline-start: 10px;">
        <li>
          <i>All funds,</i> ranking all mutual funds and ETFs* against
          each other
        </li>
        <li>
          <i>By group,</i> the default setting, ranking funds against other
          funds in the same Group of Morningstar Categories.
        </li>
        <li>
          <i>By category,</i> ranking funds against other funds in
          the same Morningstar Category
        </li>
      </ul>
      *The research universe is approximately 4,900 open end mutual
      funds and exchange traded funds domiciled in the U.S. with at
      least 40% of holdings in stocks.
    `
    this.state = {
      params,
      tooltipHtml: format.tooltipHtml(tooltipText)
    }
  }
  //
  render() {
    return (
      <div styleName='active-group-control-wrap'>
        { /* Explanatory tooltip */ }
        <div
          styleName='active-group-control-lbl'
          data-multiline
          data-effect={'solid'}
          data-tip={this.state.tooltipHtml}
          data-for='group-control-lbl'
          data-place='bottom'
          data-html
        >
          <strong>Gender equality ranking</strong>
          <LinkIcon faclass='fa-info-circle' />
        </div>
        { /* For each grouping type, render a form control option
             If it's the active grouping, render different styling
             Attach state-update to onClick of form control options */ }
        <div styleName='active-group-control-opt-wrp'>
          {this.state.params.map((el,ix)=>{
            return <div
              key={'grping_'+ix}
              styleName={
                this.props.activeGrouping !== el[1] ?
                  'active-group-control-opt' :
                  'active-group-control-opt-actv'
              }
              onClick={() => { this.props.changeActiveGrouping(el[1]) }}
            >
              <span
                styleName={
                  this.props.activeGrouping !== el[1] ?
                    'crt-inv' :
                    'crt-vis'
                }
              >
                <LinkIcon faclass='fa-caret-right' />
              </span>
              &nbsp;
              {el[0]}
            </div>
          })}
        </div>
        <ReactTooltip id='group-control-lbl'/>
      </div>
    )
  }
}


@CSSModules(Styles, {allowMultiple:true})
class IyvListSelect extends Component {
  static propTypes = {
    selectedFilters: PropTypes.object,
    filterOptions: PropTypes.func,
    selectFilter: PropTypes.func,
    idx: PropTypes.number,
    label: PropTypes.string,
    name: PropTypes.string,
    defaultFilter: PropTypes.string
  }
  //
  constructor(props) {
    super(props)
  }
  //
  render() {
    const value = this.props.selectedFilters[this.props.name] || this.props.defaultFilter
    const options = this.props.filterOptions(this.props.name)

    const asRadio = (
      options.length <= 3 &&
      (
        name !== 'fffGrade' &&
        name !== 'ffbGrade' &&
        name !== 'ffiGrade' &&
        name !== 'dffGrade' &&
        name !== 'gefGrade' &&
        name !== 'wffGrade' &&
        name !== 'gffGrade' &&
        name !== 'pffGrade' &&
        name !== 'tffGrade'
      )
    )
    //
    return <div
      key={'iyv-list-select-' + this.props.idx}
      styleName='filter'
    >
      <div styleName='filter-label'>
        {this.props.label}
      </div>
      { /* if it's a radio, a <RadioGroup> */
        asRadio ?
          <RadioGroup
            name={this.props.name}
            Component='form'
            selectedValue={value}
            onChange={this.props.selectFilter(this.props.name)}
          >
            { /* for each option in this radio group, a <Radio/> */
              options.map((option) => {
                return <label
                  key={option.label}
                  styleName='filter-radio-label'
                >
                  <Radio value={option.value} />
                  &nbsp;{option.label}
                </label>
              })
            }
          </RadioGroup> :
          null
      }
      { /* if it's not a radio, a <Select/> */
        !asRadio ?
          <Select
            name='form-field-name'
            value={value}
            options={options}
            onChange={this.props.selectFilter(this.props.name)}
          /> :
          null
      }
    </div>
  }
}


@CSSModules(Styles, {allowMultiple:true})
export default class IyvListFilters extends Component {
  static propTypes = {
    activeGrouping: PropTypes.string,
    showFilters: PropTypes.bool,
    currentTutorial: PropTypes.number,
    showTutorial: PropTypes.bool,
    clickCloseTutorial: PropTypes.func,
    changeActiveGrouping: PropTypes.func,
    selectFilter: PropTypes.func,
    filterOptions: PropTypes.func,
    selectedFilters: PropTypes.object,
    filters: PropTypes.array,
    defaultFilter: PropTypes.string
  }
  //
  constructor(props) {
    super(props)
  }
  //
  render() {
    const renderFiltersCol = (order) => {
      return <Col xs={12} sm={6}>
        { /* Filters are a global at top of file */
          this.props.filters
            .filter((filter) => {
              // order === 0 means left column of filters
              // order === 1 means left column of filters
              return filter.order === order
            })
            .map((filter, idx) => {
              return <IyvListSelect
                selectedFilters={this.props.selectedFilters}
                filterOptions={this.props.filterOptions}
                selectFilter={this.props.selectFilter}
                idx={idx}
                label={filter.label}
                name={filter.state}
                defaultFilter={this.props.defaultFilter}
              />
            })
        }
      </Col>
    }
    return <div
      styleName={
        this.props.currentTutorial === 2 && this.props.showTutorial ?
          'tutorial-highlight-filters-wrap' :
          null
      }
      onClick={this.props.clickCloseTutorial}
    >
      <SlideDown>
        { /* show the slide down panel of filters or don't */
          this.props.showFilters ?
            (
              <div styleName='filters'>
                <div styleName='filters-info'>
                  Filter your search results&nbsp;
                  <span
                    data-multiline
                    data-effect={'solid'}
                    data-tip={
                      format.tooltipHtml(
                        'Use the settings to control your search ' +
                          'results. Hide and show funds by grade, asset ' +
                          'manager, fund category, and more.'
                      )
                    }
                    data-place='bottom'
                    data-for='filters-tooltip'
                    data-html
                    className='fa fa-info-circle'
                  />
                </div>
                <ReactTooltip id='filters-tooltip'/>
                <Row>
                  {renderFiltersCol(0)}
                  {renderFiltersCol(1)}
                </Row>
                <div styleName='filters-info-2'>
                  Filter by issue
                </div>
                <Row>
                  {renderFiltersCol(2)}
                  {renderFiltersCol(3)}
                </Row>
                { /* if GEF, show group controls for ranking
                  config.app.title === 'Gender Equality Funds' ?
                    <Row>
                      <IyvListGroupControl
                        activeGrouping={this.props.activeGrouping}
                        changeActiveGrouping={this.props.changeActiveGrouping}
                      />
                    </Row> :
                    null
                 */ }
              </div>
            ) :
            null
        }
      </SlideDown>
    </div>
  }
}
